import {api, fetchNextApiCall} from 'app/services/api';
import {catchDataError, parseLinkHeader} from 'app/helpers/apiHelpers';

const getMatchDuelsStats = matchSlug => {
  return api.get(`/matches/${matchSlug}/comparisons`);
};

const getMatchDuelsMatches = matchSlug => {
  return api.get(`/matches/${matchSlug}/comparisons/matches`);
};

function updateMatchDuelsStats(data) {
  return {
    type: 'MATCH_DUELS_STATS_UPDATE',
    data,
  };
}

function errorMatchDuelsStats(data) {
  return {
    type: 'MATCH_DUELS_STATS_ERROR',
    data,
  };
}

function fetchingMatchDuelsStats() {
  return {
    type: 'MATCH_DUELS_STATS_FETCHING',
  };
}

function updateMatchDuelsMatches(data) {
  return {
    type: 'MATCH_DUELS_MATCHES_UPDATE',
    data,
  };
}

function errorMatchDuelsMatches(data) {
  return {
    type: 'MATCH_DUELS_MATCHES_ERROR',
    data,
  };
}

function fetchingMatchDuelsMatches() {
  return {
    type: 'MATCH_DUELS_MATCHES_FETCHING',
  };
}

function fetchMatchDuels(matchSlug, dispatchRedux, reloading) {
  return function (dispatch, state) {
    let responseStats;
    if (!matchSlug) {
      return;
    }
    if (!reloading) {
      dispatch(fetchingMatchDuelsStats());
      responseStats = getMatchDuelsStats(matchSlug)
        .then(response => {
          const stats = response.data;
          dispatch(updateMatchDuelsStats(stats));
        })
        .catch(error => {
          const errorData = catchDataError(error);
          dispatch(errorMatchDuelsStats(errorData));
        });
    }

    const {isFetching, nextUrl} = state.matches;
    if (isFetching || nextUrl === null) {
      return;
    }
    const fetchFunc = nextUrl ? fetchNextApiCall(nextUrl) : getMatchDuelsMatches(matchSlug);
    dispatch(fetchingMatchDuelsMatches());
    const responseMatches = fetchFunc
      .then(response => {
        const meta = parseLinkHeader(response.headers.link);
        const nextUrl = meta.next ? meta.next : null;
        dispatch(updateMatchDuelsMatches({items: response.data, nextUrl}));
      })
      .catch(error => {
        const errorData = catchDataError(error);
        dispatch(errorMatchDuelsMatches(errorData));
      });

    return Promise.all([responseStats, responseMatches]);
  };
}

export {fetchMatchDuels};
